var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteMedical = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/medical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/medical",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/medical"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2746365,9.86268174 L20.1373183,9.86268174 L20.1373183,4.70597738 C20.1373183,3.75605816 19.3812601,3 18.4313409,3 L15,3 L11.5686591,3 C10.6187399,3 9.86268174,3.75605816 9.86268174,4.70597738 L9.86268174,9.86268174 L4.70597738,9.86268174 C3.75605816,9.86268174 3,10.6187399 3,11.5686591 L3,18.4313409 C3,19.3812601 3.75605816,20.1373183 4.70597738,20.1373183 L9.86268174,20.1373183 L9.86268174,25.2940226 C9.86268174,26.2439418 10.6187399,27 11.5686591,27 L15,27 L18.4313409,27 C18.6639742,27 18.8966074,26.9612278 19.0904685,26.8642973 C19.5945073,26.6510501 19.9822294,26.1857835 20.098546,25.6429725 C20.1179321,25.5266559 20.1373183,25.4103393 20.1373183,25.2940226 L20.1373183,20.1373183 L25.2940226,20.1373183 C26.2439418,20.1373183 27,19.3812601 27,18.4313409 L27,11.5686591 C27,10.6187399 26.2245557,9.86268174 25.2746365,9.86268174 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-medical.07781a059c8db6431d7c90d49e0e0326.svg";